/** Theme colors for the booking page. Only consumer is the URL builder below. */
const CALENDLY_PAGE_SETTINGS = {
  backgroundColor: '0f1a11',
  textColor: 'ffffff',
  primaryColor: '2563eb',
};

function buildCalendlyUrl() {
  const url = new URL(import.meta.env.VITE_CALENDLY_URL);
  url.searchParams.set('background_color', CALENDLY_PAGE_SETTINGS.backgroundColor);
  url.searchParams.set('text_color', CALENDLY_PAGE_SETTINGS.textColor);
  url.searchParams.set('primary_color', CALENDLY_PAGE_SETTINGS.primaryColor);

  return url.toString();
}

/** Calendly booking URL with theme colors baked in, for use in plain links (new tab). */
export const CALENDLY_LINK_URL = buildCalendlyUrl();

/** Origin Calendly's embedded iframe posts its events from. */
export const CALENDLY_ORIGIN = 'https://calendly.com';

declare global {
  interface Window {
    /** Provided by the widget.js script tag in frontend/marketing/src/layouts/Head.astro. */
    Calendly?: {
      initPopupWidget(options: { url: string }): void;
    };
  }
}

/**
 * Opens the Calendly booking popup.
 *
 * widget.js is a deferred script tag, so it has run long before a user can click. If it
 * failed to load anyway (Calendly outage, blocked third-party script), fall back to the
 * plain link rather than dropping the click — a booking in a new tab still converts.
 */
export function openCalendlyPopup() {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_LINK_URL });

    return;
  }

  window.open(CALENDLY_LINK_URL, '_blank', 'noopener,noreferrer');
}
